export type Locale = 'ja' | 'en';

export function getBrowserLocale(): Locale {
  if (typeof navigator === 'undefined') {
    return 'ja';
  }

  return navigator.language.toLowerCase().startsWith('ja') ? 'ja' : 'en';
}

export function t(ja: string, en: string): string {
  return getBrowserLocale() === 'ja' ? ja : en;
}
